exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".splited-text p.line{color:#fff;font-family:Abhaya Libre,serif;font-weight:700;font-size:1.25em;line-height:2.5em}.splited-text p.line span{opacity:0;display:inline-block;transform:translate3d(0,50px,0)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7171e1e0","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/splited-text.vue
// module id = 425
// module chunks = 0